import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ReactDropzone from 'react-dropzone';
import css from 'styled-jsx/css';

const { className: dropzoneClass, styles: dropzoneStyles } = css.resolve`
  div {
    position: relative;
    width: 100%;
    height: 120px;
    border-width: 3px;
    border-color: var(--brand-primary);
    border-style: dashed;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--muted-gray);
  }
  div:focus {
    outline: none;
  }
  @media (min-width: 768px) {
    div {
      height: 200px;
    }
  }
`;

export default function OrgBranding(props) {
  const { org, onDrop } = props;
  return (
    <Fragment>
      <div className="form-group">
        <div className="row">
          <label htmlFor="logo">Company Logo</label>
        </div>
        <div className="row">
          <div className="col-12" style={{ marginTop: '0.60rem' }}>
            <div className="row">
              <div className="logo-preview col-12 col-md-4 d-flex align-items-center justify-content-start justify-content-md-center">
                <img
                  src={org.logo}
                  alt="organization logo"
                  className="img-fluid mh-100"
                />
              </div>
              <div className="col-12 col-md-8">
                <ReactDropzone
                  accept={{ 'image/*': [] }}
                  multiple={false}
                  onDrop={onDrop}
                >
                  {({ getRootProps, getInputProps }) => {
                    const inputProps = getInputProps();
                    return (
                      <div {...getRootProps()} className={dropzoneClass}>
                        <input {...inputProps} />
                        <span>Drop files here or click to upload.</span>
                      </div>
                    );
                  }}
                </ReactDropzone>
              </div>
            </div>
          </div>
        </div>
      </div>
      {dropzoneStyles}
      <style jsx>{`
        .input-group-text {
          padding: 0;
        }
        .logo-preview {
          width: 90%;
          height: auto;
          margin-top: 1rem;
          margin-bottom: 2rem;
        }
        @media (min-width: 768px) {
          .logo-preview {
            height: auto;
            margin-top: 0;
            margin-bottom: 0;
          }
        }
      `}</style>
    </Fragment>
  );
}

OrgBranding.propTypes = {
  org: PropTypes.object,
  onDrop: PropTypes.func,
};

OrgBranding.defaultProps = {
  org: { settings: {} },
};
